import React from 'react'
import PropTypes from 'prop-types'
import cn from 'comma-number'
import { useConfiguration } from 'Root/ConfigurationProvider'

import PieGraph from '../PieGraph'

export const getPopulationPieColors = (isCondos) => (
  isCondos ? {
    pieOne: '#0097A7',
    pieTwo: '#075762',
    pieThree: '#CF5CB6',
    pieFour: '#90D4D4',
    pieFive: '#35BAC8',
    pieSix: '#900772',
  } : {
    pieOne: '#07364B',
    pieTwo: '#018484',
    pieThree: '#E8194B',
    pieFour: '#25BEBE',
    pieFive: '#5E7387',
    pieSix: '#186685',
  }
)

const getGroupAge = (pieColors) => ({
  '0_to_14': {
    label: '0 - 14 years old',
    mobileLabel: '0 - 14 yrs',
    color: pieColors.pieOne,
  },
  '15_to_19': {
    label: '15 - 19 years old',
    mobileLabel: '15 - 19 yrs',
    color: pieColors.pieTwo,
  },
  '20_to_34': {
    label: '20 - 34 years old',
    mobileLabel: '20 - 34 yrs',
    color: pieColors.pieThree,
  },
  '35_to_49': {
    label: '35 - 49 years old',
    mobileLabel: '35 - 49 yrs',
    color: pieColors.pieFour,
  },
  '50_to_64': {
    label: '50 - 64 years old',
    mobileLabel: '50 - 64 yrs',
    color: pieColors.pieFive,
  },
  '65_plus': {
    label: '65+ years old',
    mobileLabel: '65+ yrs',
    color: pieColors.pieSix,
  },
})

const groupAgeModifier = {
  '0_to_14': ['0_to_4', '5_to_9', '10_to_14'],
  '65_plus': ['65_to_79', '80_plus'],
}

const Population = ({ desktopView, data, xsView }) => {
  const { IS_CONDOS } = useConfiguration()
  const populationData = data.data?.attributes?.population_age?.variables
  const totalPopulation = data.data?.attributes?.population_total?.variables?.find(
    item => item.variable === 'total_individuals')?.value
  const pieColors = getPopulationPieColors(IS_CONDOS)
  const groupAge = getGroupAge(pieColors)

  const modifiedAgeGroups = {
    '0_to_14': { 'variable': '0_to_14', 'value': 0, 'label': '0 to 14' },
    '65_plus': { 'variable': '65_plus', 'value': 0, 'label': '65 and over' },
  }
  populationData.forEach(ageGroup => {
    if(groupAgeModifier['0_to_14'].includes(ageGroup.variable)) {
      modifiedAgeGroups['0_to_14'].value += ageGroup.value
    } else if(groupAgeModifier['65_plus'].includes(ageGroup.variable)) {
      modifiedAgeGroups['65_plus'].value += ageGroup.value
    } else {
      modifiedAgeGroups[ageGroup.variable] = {
        ...ageGroup,
        value: ageGroup.value,
      }
    }
  })

  const sixtyFivePlus = modifiedAgeGroups['65_plus']

  delete modifiedAgeGroups['65_plus']

  modifiedAgeGroups['65_plus'] = sixtyFivePlus

  const groupArrays = Object.values(modifiedAgeGroups)

  return (
    <div>
      <h4>Population</h4>

      <PieGraph
        desktopView={desktopView}
        xsView={xsView}
        groupArrays={groupArrays}
        groupHash={groupAge}
        centerTitle={'Total'}
        centerValue={totalPopulation ? cn(totalPopulation) : ''}
        height={desktopView ? 160 : 260}
      />
    </div>
  )
}


Population.propTypes = {
  data: PropTypes.shape({
    data: PropTypes.shape({
      attributes: PropTypes.shape({
        population_age: PropTypes.shape({
          variables: PropTypes.arrayOf(PropTypes.shape({})),
        }),
        population_total: PropTypes.shape({
          variables: PropTypes.arrayOf(PropTypes.shape({})),
        }),
      }),
    }),
  }),
  desktopView: PropTypes.bool,
  xsView: PropTypes.bool,
}

export default Population
